var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component/icon/ic_Place"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined Shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C14.2091 15 16 13.2091 16 11C16 8.79086 14.2091 7 12 7C9.79086 7 8 8.79086 8 11C8 13.2091 9.79086 15 12 15ZM12 13C10.8954 13 10 12.1046 10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11C14 12.1046 13.1046 13 12 13Z",
    fill: "url(#paint0_linear_1500_266658)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10.8701C3 5.96756 7.03307 2 12 2C16.9669 2 21 5.96756 21 10.8701C21 13.2916 20.0094 15.5597 18.295 17.2093L12.7013 22.7128C12.3122 23.0957 11.6879 23.0957 11.2987 22.7129L5.69735 17.2024C3.98444 15.5459 3 13.2842 3 10.8701ZM16.9003 15.7759C18.2357 14.4909 19 12.7409 19 10.8701C19 7.07953 15.8696 4 12 4C8.13037 4 5 7.07953 5 10.8701C5 12.7352 5.75964 14.4804 7.09383 15.7707L12 20.5972L16.9003 15.7759Z",
    fill: "url(#paint1_linear_1500_266658)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1500_266658",
    x1: 1.65,
    y1: 0.95,
    x2: 58.5021,
    y2: 11.9032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2064FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1500_266658",
    x1: 1.65,
    y1: 0.95,
    x2: 58.5021,
    y2: 11.9032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684EFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2064FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvCompleted);
export default __webpack_public_path__ + "static/media/sv_completed.906c2951a3b15137d09f81acf3f6719c.svg";
export { ForwardRef as ReactComponent };